// extracted by mini-css-extract-plugin
module.exports = {"buttonWrap":"ProtocolModal_style_buttonWrap__2t2lB","content":"ProtocolModal_style_content__10E0T"};